import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'suggestions';

const SUGGESTIONS_ENDPOINTS = {
  listSuggestions: () => formatEndpoint('', namespace),
  retrieveSuggestion: (id: string) => formatEndpoint(`${id}`, namespace),
};

export default SUGGESTIONS_ENDPOINTS;
